module.exports = __webpack_public_path__ + "media/images/flags/fo-27f92db9645246376f67caad47173677.svg";